// Mapping between compliancetype and relation field ids

const getFieldIdForCompliancy = (compliancy, status, relationType = null) => {
  switch (compliancy) {
    case 0: // assignment letter
    case 7: // authorization letter
      return '6b93b564-0865-488b-827a-480bc004d519';
    case 1: // risk assessment
      return '60f7a302-540f-47e9-a72f-2311362c57b5;aml-risk-assessment-section'; // AML
    case 2: // beneficiaries
      if (status === 0) return '2ca70dce-5a5d-49c1-a9d6-776c97e14fff'; // Linked relations
      return '60f7a302-540f-47e9-a72f-2311362c57b5';
    case 3: // id card
      if (relationType === 0) return '2ca70dce-5a5d-49c1-a9d6-776c97e14fff'; // Linked relations for companies
      return 'f0f34e57-46b0-4ebc-8954-73f4d9af4d4a';
    case 4: // authorizations
      return '3d6de6a8-b4f2-428a-a8f5-c5ee2467c913';
    case 5: // ubo
      return 'dce8c441-9525-455b-acb4-24c570f2d518';
    case 6: // identification
      if (status === 2) return '60f7a302-540f-47e9-a72f-2311362c57b5';
      return '60f7a302-540f-47e9-a72f-2311362c57b5;aml-documents-section';
    case 8: // detailed risk assessment
      if (status === 0)
        return '60f7a302-540f-47e9-a72f-2311362c57b5;aml-detailed-risk-assessment-section'; // AML
      return '60f7a302-540f-47e9-a72f-2311362c57b5;aml-documents-section'; // AML
    default:
      return null;
  }
};
export default getFieldIdForCompliancy;
